import { useState, useEffect, ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@/Domain/components/Shared/CheckBox/Checkbox';
import { Input } from '@/Domain/components/Shared/Input/Input';

type Props = {
  value?: string;
  onChange?: (value: { useFilterPhrase: boolean; filterPhrase: string }) => void;
  reset?: boolean;
  onResetComplete?: () => void;
  error?: boolean;
};

export const FilterPhraseOption = ({
  value = '',
  onChange,
  reset,
  onResetComplete,
  error,
}: Props) => {
  const { t } = useTranslation(['knowledge_base']);
  const [useFilterPhrase, setUseFilterPhrase] = useState(false);
  const [filterPhrase, setFilterPhrase] = useState(value);

  useEffect(() => {
    if (onChange) {
      onChange({ useFilterPhrase, filterPhrase });
    }
  }, [useFilterPhrase, filterPhrase, onChange]);

  useEffect(() => {
    if (reset) {
      setUseFilterPhrase(false);
      setFilterPhrase('');
      if (onResetComplete) {
        onResetComplete();
      }
    }
  }, [reset, onResetComplete]);

  const handleUseFilterPhraseChange = (checked: boolean) => {
    setUseFilterPhrase(checked === true);
  };

  const handleFilterPhraseChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterPhrase(e.target.value);
  };

  return (
    <div className="flex items-start gap-2">
      <Checkbox
        id="filter-phrase"
        checked={useFilterPhrase}
        onCheckedChange={handleUseFilterPhraseChange}
      />
      <div className="flex flex-col">
        <label htmlFor="filter-phrase" className="text-sm font-medium cursor-pointer">
          {t('modals.upload_url.filter_phrase.label')}
        </label>
        <p className="text-sm text-foreground-subtle">
          {t('modals.upload_url.filter_phrase.description')}
        </p>
        {useFilterPhrase && (
          <div className="mt-2">
            <Input
              placeholder={t('modals.upload_url.filter_phrase.placeholder')}
              value={filterPhrase}
              onChange={handleFilterPhraseChange}
              error={(useFilterPhrase && filterPhrase.trim() === '') || !!error}
            />
            {useFilterPhrase && filterPhrase.trim() === '' && (
              <p className="text-red-500 text-sm mt-1">
                {t('modals.upload_url.filter_phrase.error_required', 'This field is required')}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
